export default {
  'en': 'English',
  'tc': 'Chinese',
  'short': {
    'en': 'EN',
    'tc': 'TC',
  }
}